import { useState, useEffect } from "react";
import "../../../App.css";
import Listdelete from "./ListDelete";
import Add from "./Add";

const baseURL = process.env.REACT_APP_API_JOBS;
function Experience(props) {
  const { visible, moamad, hagsha_aharon, counter, setCounter } = props;
  const increment = () => {
    setCounter(counter + 1);
  };

  if (!visible) return;
  return (
    <>
      <Add
        increment={increment}
        counter={counter}
        hagsha_aharon={hagsha_aharon}
        moamad={moamad}
      />
      <Listdelete
        increment={increment}
        counter={counter}
        setCounter={setCounter}
        moamad_id={moamad.id}
        moamad={moamad}
        hagsha_aharon={hagsha_aharon}
      />
    </>
  );
}

export default Experience;
